import { useMemo } from 'react';

import type { ComponentId } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import { selectAssetsForComponent } from '../../modules/components';
import { useVendor } from '../VendorPovider/VendorPovider';

export const useComponentAssets = (id: ComponentId) => {
  const { vendor } = useVendor();
  const assets = useAppSelector((state) =>
    selectAssetsForComponent(state, vendor, id)
  );
  const foundAssetIds = assets.map(({ id }) => id).join(',');

  // deliberately skipping assets in dependency list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => assets, [foundAssetIds]);
};
